import {
  Box,
  Button,
  Flex,
  IconButton,
  ListItem,
  Text,
  Tooltip,
  UnorderedList,
} from '@chakra-ui/react';

import { AddToCartIcon } from './icons';
import type {
  VoucherRuleProductAction,
  VoucherRuleProductGroup,
} from './rule-product-utils';

interface VoucherRuleProductActionsProps {
  groups: VoucherRuleProductGroup[];
  isDisabled?: boolean;
  showAddButton?: boolean;
  onAddProduct: (product: VoucherRuleProductAction) => void;
}

const VoucherRuleProductActions = ({
  groups,
  isDisabled,
  showAddButton = true,
  onAddProduct,
}: VoucherRuleProductActionsProps) => {
  if (!groups.length) {
    return null;
  }

  return (
    <UnorderedList spacing="2px" pl="16px" m={0} color="#FF8D28">
      {groups.map((group) => {
        const primaryProduct = group.products[0];
        return (
          <ListItem key={group.id}>
            <Flex align="center" justify="space-between" gap="12px">
              <Text fontSize="12px" color="#FF8D28">
                {group.message}
              </Text>
              {primaryProduct &&
                showAddButton &&
                (primaryProduct.isOutOfStock ? (
                  <Button
                    size="xs"
                    variant="outline"
                    color="gray.500"
                    borderColor="gray.500"
                    cursor="not-allowed"
                    _disabled={{ opacity: 1 }}
                    _hover={{
                      color: 'gray.300',
                      borderColor: 'gray.300',
                    }}
                    isDisabled
                  >
                    Out of Stock
                  </Button>
                ) : (
                  <Tooltip
                    label={`Tambahkan ${primaryProduct.productName} ke keranjang`}
                    placement="top"
                    hasArrow
                    shouldWrapChildren
                  >
                    <Box as="span" pointerEvents="auto">
                      <IconButton
                        aria-label="Tambahkan produk ke keranjang"
                        icon={<AddToCartIcon />}
                        size="sm"
                        variant="ghost"
                        minW="auto"
                        h="auto"
                        px="12px"
                        py="4px"
                        onClick={(event) => {
                          event.stopPropagation();
                          onAddProduct(primaryProduct);
                        }}
                        isDisabled={isDisabled}
                      />
                    </Box>
                  </Tooltip>
                ))}
            </Flex>
          </ListItem>
        );
      })}
    </UnorderedList>
  );
};

export default VoucherRuleProductActions;
